/* eslint-disable no-unused-vars */
import alert from '@/plugins/alert'
import { Appointment } from '@/plugins/api'

const getAppointmentLookupQuery = (query = {}) => {
  const keyMap = {
    appointmentDate_gte: 'date_gte',
    appointmentDate_lte: 'date_lte',
    appointmentStatus: 'status',
    appointmentStatus_in: 'status_in',
  }
  return Object.keys(keyMap).reduce((result, key) => {
    if (query[key]) result[keyMap[key]] = query[key]
    return result
  }, {})
}

const getAppointmentLeadId = appointment => {
  if (!appointment || !appointment.lead) return ''
  return typeof appointment.lead === 'string' ? appointment.lead : appointment.lead.id
}

const getLatestAppointmentsByLead = appointments => {
  return appointments.reduce((result, appointment) => {
    const leadId = getAppointmentLeadId(appointment)
    if (leadId && !result[leadId]) result[leadId] = appointment
    return result
  }, {})
}

// Cap the number of lead ids per request so the GET url length stays within
// server/proxy limits (a single lead_in param is ~32 chars; 50 ids keeps the
// query string well under the typical ~8KB cap). Without this, "show all"
// builds a url with hundreds of lead_in params and the request fails.
const LEAD_IN_BATCH_SIZE = 50

const chunk = (items, size) => {
  const batches = []
  for (let i = 0; i < items.length; i += size) {
    batches.push(items.slice(i, i + size))
  }
  return batches
}

export default {
  namespaced: true,
  state: {
    Leads: [],
    count: 0,
  },
  actions: {
    async fetchAppointments({ commit }, options) {
      const appointments = await Appointment.fetch({ ...options })
      return appointments
    },
    async fetchAppointment({ commit }, appId) {
      const appointment = await Appointment.fetchOne(appId)
      return appointment
    },
    async fetchLatestAppointmentsByLead(_, { leadIds = [], query = {} } = {}) {
      if (!leadIds.length) return {}
      const lookupQuery = getAppointmentLookupQuery(query)
      const batches = chunk(leadIds, LEAD_IN_BATCH_SIZE)
      const results = await Promise.all(
        batches.map(batchIds =>
          Appointment.fetch({
            lead_in: batchIds,
            ...lookupQuery,
            _sort: 'date:DESC',
          })
        )
      )
      // _sort is applied per request, so flatten then keep the first (latest)
      // appointment seen for each lead across all batches.
      const appointments = results.reduce((acc, batch) => acc.concat(batch || []), [])
      return getLatestAppointmentsByLead(appointments)
    },
    async createAppointment({ commit }, data) {
      const newApp = await Appointment.create(data)
      return newApp
    },
  },
}

/* eslint-enable no-unused-vars */
